import NotFooterLayout from "layouts/NotFooterLayout";
import UpdateProduct from "components/ManageProduct/UpdateProduct";
import { FC } from "react";
import { useParams } from "react-router-dom";

const UpdateProductPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <NotFooterLayout namePage="แก้ไขสินค้า" >
        <div className="layout-content">
          <UpdateProduct id={id ?? ""} />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default UpdateProductPage;
